<div [hidden]="!loading">
  <ab-spinner></ab-spinner>
</div>
<div
  class="alert alert-info"
  *ngIf="memberCount === 1 && comments?.length === 0 && !loading"
>
  Want to share?
  <a class="alert-link" href="/users" target="_self">
    Invite more team members</a
  >
  and discuss your errors.
</div>
<div
  class="comment"
  *ngFor="let comment of comments; last as $last; trackBy: trackById"
  [ngClass]="{ 'comment--last': $last }"
>
  <div class="float-left">
    <ab-gravatar
      class="avatar avatar--large"
      [user]="comment.user"
      [size]="50"
    ></ab-gravatar>
  </div>
  <div class="comment__body">
    <div class="float-right">
      <span
        class="comment__occurred"
        title="{{ comment.createdAt | date: 'MMM dd, y HH:mm:ss Z' }}"
      >
        <ab-time-ago [time]="comment.createdAt"></ab-time-ago></span
      ><span *ngIf="comment.user?.id === user.id">&nbsp;&nbsp;</span>
      <button
        class="btn comment__delete"
        type="button"
        title="Delete this comment"
        *ngIf="comment.user?.id === user.id"
        (click)="destroy(comment)"
      >
        <i class="glyphicon glyphicon-times"></i>
      </button>
    </div>
    <h5 class="comment__author">
      {{ comment.user?.nameOrEmail || "Somebody" }}
    </h5>
    <span class="text" [abMarkdown]="comment.comment"></span>
  </div>
</div>
<div [hidden]="loading">
  <form role="form" (submit)="create()">
    <div class="form-group">
      <label class="sr-only" for="comment">Comment</label>
      <textarea
        class="form-control ab-form-control comment-textarea"
        rows="1"
        name="comment[comment]"
        placeholder="Add your comment here..."
        [(ngModel)]="comment.comment"
        [abSetFocusOn]="'commentList:textarea'"
      ></textarea>
    </div>
    <input
      class="btn"
      type="submit"
      value="Comment"
      [disabled]="commenting || !comment.comment"
    />
    <div class="markdown-notice">
      <i
        class="markdown-notice__icon glyphicon glyphicon-markdown-mark-solid"
      ></i>
      <ab-external-link
        href="https://daringfireball.net/projects/markdown/syntax"
        >Styling with Markdown is supported</ab-external-link
      >
    </div>
  </form>
</div>
